import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import clientApi from "../../api/client";
import { selectClientRightGroupList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getClientRightGroupList(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientRightGroupList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.clientRightGroupListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const rightGroupList = await clientApi.getClientRightGroupList(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, rightGroupList);

      dispatch(
        actions.clientRightGroupListFetchSuccess({
          data: rightGroupList.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.clientRightGroupListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getClientRightGroupListCount(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientRightGroupList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.clientRightGroupListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await clientApi.getClientRightGroupCount(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();

      dispatch(actions.clientRightGroupListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.clientRightGroupListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeClientRightGroupListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientRightGroupListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeClientRightGroupListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientRightGroupListChangePage(page));
  };
}

export function changeClientRightGroupListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientRightGroupListChangeFilter(filter));
  };
}

export function clientRightGroupListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectClientRightGroupList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.clientRightGroupListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.clientRightGroupListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
